import dev from './resources.dev';
import enGB from './resources.en-GB';

const resources = {
  dev,
  'en-GB': enGB
};

export default resources;
